export default __webpack_public_path__ + "static/media/sec_hand.d6d11f82.svg";